// Einzige Quelle für das Aussehen der Arbeitsblatt-Bausteine.
// Wird sowohl im Editor (per <style>-Injektion) als auch im PDF-Druck-Dokument genutzt,
// damit Bildschirm und Ausdruck identisch aussehen.

export const WORKSHEET_CSS = `
.ws-content {
  font-family: var(--ws-family, 'Manrope', system-ui, -apple-system, 'Segoe UI', sans-serif);
  font-size: var(--ws-font, 15px);
  line-height: var(--ws-lh, 1.6);
  color: #1B1714;
  counter-reset: ws-aufgabe;
}
.ws-content p { margin: 8px 0; }
.ws-content h1 { font-size: 1.7em; font-weight: 700; margin: 0 0 8px; letter-spacing: -0.01em; }
.ws-content h2 { font-size: 1.3em; font-weight: 700; margin: 18px 0 8px; }
.ws-content h3 { font-size: 1.1em; font-weight: 600; margin: 14px 0 6px; }
.ws-content ul, .ws-content ol { padding-left: 24px; margin: 8px 0; }
.ws-content li { margin: 3px 0; }
.ws-content a { color: #2238B5; }

/* Aufgabe (automatische Nummerierung per CSS-Counter) */
.ws-task { display: flex; gap: 10px; margin: 16px 0; break-inside: avoid; page-break-inside: avoid; }
.ws-task-num { flex: 0 0 auto; }
.ws-task-num::before {
  counter-increment: ws-aufgabe;
  content: "Aufgabe " counter(ws-aufgabe);
  display: inline-block; background: #E1E4F5; color: #2238B5;
  font-weight: 700; font-size: 0.78em; padding: 4px 11px; border-radius: 999px; white-space: nowrap;
}
.ws-task-body { flex: 1 1 auto; }
.ws-task-body p { margin: 2px 0; }

/* Schreiblinien / Lineatur */
.ws-rule { margin: 12px 0; break-inside: avoid; }
.ws-rule-row { position: relative; }
.ws-rule--simple .ws-rule-row { height: 11mm; border-bottom: 1.6px solid #1B1714; }
.ws-rule--answer .ws-rule-row { height: 10mm; border-bottom: 1px solid #8A8278; }
.ws-rule--haus .ws-rule-row { height: 12mm; border-bottom: 1.7px solid #1B1714; }
.ws-rule--haus .ws-rule-row::before { content: ""; position: absolute; left: 0; right: 0; top: 50%; border-top: 1px dashed #B8B0A1; }
.ws-rule--haus .ws-rule-row::after { content: ""; position: absolute; left: 0; right: 0; top: 0; border-top: 1px solid #D9D2C2; }
.ws-rule--kl2 .ws-rule-row { height: 10mm; border-bottom: 1.7px solid #1B1714; }
.ws-rule--kl2 .ws-rule-row::before { content: ""; position: absolute; left: 0; right: 0; top: 45%; border-top: 1px dashed #B8B0A1; }

/* Lückentext */
.ws-cloze { margin: 10px 0; }
.ws-gap { display: inline-block; min-width: 80px; border-bottom: 1.6px solid #1B1714; margin: 0 4px; }
.ws-wordbank { margin: 6px 0 12px; padding: 8px 12px; border: 1.4px dashed #C9BFA6; border-radius: 10px; background: #FBF7EE; }
.ws-wordbank-label { font-weight: 700; color: #8A8278; margin-right: 6px; }
.ws-word { display: inline-block; background: #fff; border: 1px solid #E3DBC8; border-radius: 6px; padding: 2px 10px; margin: 2px 4px; }

/* Multiple-Choice */
.ws-mc { margin: 12px 0; break-inside: avoid; }
.ws-mc-q { font-weight: 600; margin: 0 0 6px; }
.ws-opt { display: flex; align-items: center; gap: 10px; margin: 6px 0; }
.ws-box { flex: 0 0 auto; width: 16px; height: 16px; border: 1.6px solid #2238B5; border-radius: 4px; display: inline-block; }

/* Richtig / Falsch */
.ws-tf { width: 100%; border-collapse: collapse; margin: 12px 0; break-inside: avoid; }
.ws-tf th, .ws-tf td { border: 1.4px solid #C9BFA6; padding: 7px 10px; text-align: left; }
.ws-tf th { background: #EDE6D3; font-size: 0.85em; }
.ws-tf th:not(:first-child) { width: 64px; text-align: center; }
.ws-tf-box { width: 64px; text-align: center; }
.ws-tf-box::after { content: ""; display: inline-block; width: 15px; height: 15px; border: 1.5px solid #2238B5; border-radius: 4px; vertical-align: middle; }

/* Zuordnung */
.ws-match { display: flex; gap: 48px; margin: 14px 0; break-inside: avoid; }
.ws-match-col { list-style: none; padding: 0; margin: 0; flex: 1; }
.ws-match-col li { border: 1.3px solid #E3DBC8; border-radius: 8px; padding: 8px 12px; margin: 8px 0; position: relative; }
.ws-match-col li::after { content: ""; position: absolute; right: -8px; top: 50%; width: 9px; height: 9px; background: #2238B5; border-radius: 50%; transform: translateY(-50%); }
.ws-match-col--right li::after { right: auto; left: -8px; }

/* Rechenkästchen */
.ws-mathgrid { height: 60mm; border: 1.5px solid #C9BFA6; border-radius: 6px;
  background-image: linear-gradient(#E3DBC8 1px, transparent 1px), linear-gradient(90deg, #E3DBC8 1px, transparent 1px);
  background-size: 7mm 7mm; break-inside: avoid; }

/* Merkkasten */
.ws-info { position: relative; margin: 18px 0; padding: 15px 16px 12px; border: 1.6px solid #E8B445; border-radius: 12px; background: #F8EBC7; break-inside: avoid; }
.ws-info-label { position: absolute; top: -10px; left: 14px; background: #E8B445; color: #1B1714; font-weight: 700; font-size: 0.7em; text-transform: uppercase; letter-spacing: 0.06em; padding: 2px 10px; border-radius: 999px; }
.ws-info p { margin: 4px 0 0; }

/* Tabelle */
.ws-table { width: 100%; border-collapse: collapse; margin: 12px 0; }
.ws-table td { border: 1.4px solid #A69C90; padding: 8px 10px; min-width: 40px; }

/* Trennlinie */
.ws-hr { border: 0; border-top: 2px dashed #C9BFA6; margin: 20px 0; }

/* Bild */
.ws-figure { margin: 14px 0; text-align: center; break-inside: avoid; }
.ws-figure img { max-width: 100%; border-radius: 8px; }
.ws-figure figcaption { font-size: 0.82em; color: #8A8278; margin-top: 6px; }

/* Lösungen (Lösungsblatt-Modus) */
.ws-solution { background: #E2ECDC; color: #3F6748; border-radius: 4px; padding: 0 4px; font-weight: 600; }
.hide-solutions .ws-solution { background: transparent; color: transparent; font-weight: 400; border-bottom: 1.4px solid #1B1714; border-radius: 0; }

/* Mathe-Generator */
.ws-mathgen { display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px 32px; margin: 12px 0; break-inside: avoid; }
.ws-mathitem { font-variant-numeric: tabular-nums; padding: 4px 0; font-size: 1.05em; }
.ws-mathitem .ws-gap { min-width: 48px; }

/* Schmuckrahmen ums ganze Blatt (druckecht über border statt Schatten) */
.ws-frame { padding: 8mm; }
.ws-frame--none { padding: 0; }
.ws-frame--solid { border: 2.5px solid #2238B5; border-radius: 2mm; }
.ws-frame--double { border: 5px double #2238B5; border-radius: 2mm; }
.ws-frame--dashed { border: 3px dashed #5E8C68; border-radius: 3mm; }
.ws-frame--dotted { border: 4px dotted #E25C45; border-radius: 4mm; }
.ws-frame--rounded { border: 3px solid #8568C2; border-radius: 9mm; }
.ws-frame--festive { border: 6px double #E8B445; border-radius: 3mm; }
`;

// Klassenstufen-Presets: Schriftgröße + Zeilenhöhe (Recherche: jünger = größer, min. 11pt).
export interface GradePreset {
  id: string;
  label: string;
  font: string; // CSS --ws-font
  lh: string; // CSS --ws-lh
  defaultRule: 'haus' | 'kl2' | 'simple';
}

export const GRADE_PRESETS: GradePreset[] = [
  { id: 'kl1', label: 'Klasse 1', font: '19px', lh: '2.0', defaultRule: 'haus' },
  { id: 'kl2', label: 'Klasse 2', font: '17px', lh: '1.9', defaultRule: 'kl2' },
  { id: 'kl34', label: 'Klasse 3/4', font: '15px', lh: '1.7', defaultRule: 'simple' },
  { id: 'sek', label: 'Sek I', font: '13px', lh: '1.55', defaultRule: 'simple' },
];

export function presetById(id: string): GradePreset {
  return GRADE_PRESETS.find((p) => p.id === id) || GRADE_PRESETS[2];
}

// Schmuckrahmen-Stile (Grundschul-Standard)
export interface FrameDef {
  id: string;
  label: string;
}

// Schriftarten (frei lizenziert, fibel-/lesegerecht)
export interface FontDef {
  id: string;
  label: string;
  stack: string;
}

export const FONTS: FontDef[] = [
  { id: 'standard', label: 'Standard', stack: "'Manrope', system-ui, -apple-system, sans-serif" },
  { id: 'andika', label: 'Andika (Fibel)', stack: "'Andika', sans-serif" },
  { id: 'lexend', label: 'Lexend (Leseförderung)', stack: "'Lexend', sans-serif" },
  { id: 'atkinson', label: 'Gut lesbar', stack: "'Atkinson Hyperlegible', sans-serif" },
];

export function fontById(id: string): FontDef {
  return FONTS.find((f) => f.id === id) || FONTS[0];
}

export const FRAMES: FrameDef[] = [
  { id: 'none', label: 'Kein Rahmen' },
  { id: 'solid', label: 'Linie' },
  { id: 'double', label: 'Doppellinie' },
  { id: 'dashed', label: 'Gestrichelt' },
  { id: 'dotted', label: 'Gepunktet' },
  { id: 'rounded', label: 'Abgerundet' },
  { id: 'festive', label: 'Festlich' },
];

